import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueCookies from 'vue-cookies'
import VueGtag from "vue-gtag"
import VueHead from 'vue-head'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: {
    id: "UA-175678669-1"
  }
}, router);

Vue.use(VueCookies)
Vue.use(VueHead)
Vue.use(VueMeta)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
